




import { Vue, Component, Prop, Mixins } from 'vue-property-decorator'
import Modifiable from '@/mixins/Modifiable'

@Component({ name: 'v-loading' })
export default class VLoading extends Mixins(Modifiable) {
    @Prop({ type: String, default: 'primary' })
    type!: 'primary-ghost'
        | 'primary'
        | 'error-ghost'
        | 'grey-ghost'
        | 'primary-inverted'
        | 'grey-dark'
        | 'primary-dull'
        | 'danger-dull'
        | 'grey-dull'
        | 'white'

    /**
     * Button size
     *
     * @var {String}
     */
    @Prop({ type: String, default: 'md' })
    size!: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}
